import http from 'plugins/axios';

export default {
  getBalance(data) {
    return http.get({
      url: '/la/admin/wallet/balance/query',
      data
    });
  },
  getAllCoin() {
    return http.get({
      url: '/la/admin/coin/all'
    });
  }
};
